module.exports = __webpack_public_path__ + "static/media/dawn.648d6209.jpg";